export default __webpack_public_path__ + "static/media/attach-uri.14b823c7.svg";